import React from 'react';
import { Redirect } from 'react-router-dom';

import appRoutes from '../../../../app-routes';

const HomePage = () => <Redirect to={appRoutes.NOTIFICATION_TEMPLATES} push />;

export default HomePage;
